(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-tabs-links"] && !Shopify.designMode) return;
  try {
    function createProductTabLinks() {
    const container = document.querySelector(".product-tabs-links");
    const placeholder = document.getElementById("product-tabs-links--item-template");
    const sections = document.querySelector("simple-tabs").sections;
    const productTabs = document.querySelector(".product-tabs simple-tabs");

    const clickHandler = (event) => {
      const target = event.currentTarget.getAttribute("target");
      productTabs.activeSection = target;
      productTabs.scrollIntoView({ alignToTop: true });
    };

    // Read sections and create links for each one (max 3)
    Array.from(sections)
      .slice(0, 3)
      .forEach((element) => {
        const title = element.textContent.trimStart();
        const link = placeholder.content.cloneNode(true);

        const item = link.querySelector(".product-tabs-links__item");
        item.textContent = title;
        item.setAttribute("target", element.id);
        item.addEventListener("click", clickHandler);

        container.querySelector("ul").appendChild(link);
      });
  }
  
  createProductTabLinks();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-medium-review"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.scroll-to-reviews');

  if (!trigger) return;

  trigger.addEventListener('click', function () {
    const reviewsTabButton = document.querySelector('[data-title="Reviews"]');
    if (!reviewsTabButton) return;

    document.querySelector('[data-title="Reviews"] input').click();

    setTimeout(() => {
      const reviewsContent = document.querySelector(
        '#reviews, .reviews, [data-title="Reviews"]'
      );

      if (reviewsContent) {
        reviewsContent.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 200);
  });
});
  } catch(e) { console.error(e); }
})();

})();
